module.exports = __webpack_public_path__ + "img/index_part2img6.77658b8e.jpg";